module.exports = __webpack_public_path__ + "img/achievement_11.d8549f26.png";